import { Injectable } from "@angular/core";
;
var InitialPointerState = {
    left: false,
    right: false,
    wheel: 0,
    position: { x: 0, y: 0 },
    delta: { x: 0, y: 0 }
};
var InputManager = (function () {
    function InputManager() {
        this.previous_pointer_state_ = Object.assign({}, InitialPointerState);
        this.current_pointer_state_ = Object.assign({}, InitialPointerState);
    }
    Object.defineProperty(InputManager.prototype, "current_state", {
        get: function () {
            return this.current_pointer_state_;
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    InputManager.prototype.setMousePosition = function (position) {
        var current_delta = {
            x: position.x - this.previous_pointer_state_.position.x,
            y: position.y - this.previous_pointer_state_.position.y
        };
        this.current_pointer_state_.position = position;
        this.current_pointer_state_.delta = current_delta;
    };
    ;
    InputManager.prototype.setWheelDirection = function (value) {
        this.current_pointer_state_.wheel = value;
    };
    ;
    InputManager.prototype.isButtonDown = function (button) {
        return this.current_pointer_state_[button];
    };
    ;
    InputManager.prototype.wasButtonDown = function (button) {
        return this.previous_pointer_state_[button];
    };
    ;
    InputManager.prototype.isButtonPressed = function (button) {
        if (this.isButtonDown(button) && !this.wasButtonDown(button)) {
            return true;
        }
        return false;
    };
    ;
    InputManager.prototype.wasButtonReleased = function (button) {
        if (!this.isButtonDown(button) && this.wasButtonDown(button)) {
            return true;
        }
        return false;
    };
    ;
    InputManager.prototype.setMouseButton = function (button, state) {
        this.current_pointer_state_[button] = state;
    };
    ;
    InputManager.prototype.update = function () {
        this.previous_pointer_state_["left"] = this.current_pointer_state_["left"];
        this.previous_pointer_state_["right"] = this.current_pointer_state_["right"];
        this.previous_pointer_state_["wheel"] = this.current_pointer_state_["wheel"];
        this.previous_pointer_state_["position"] = this.current_pointer_state_["position"];
        this.previous_pointer_state_["delta"] = this.current_pointer_state_["delta"];
        this.current_pointer_state_["delta"] = { x: 0, y: 0 };
        this.current_pointer_state_.wheel = 0;
    };
    ;
    InputManager.decorators = [
        { type: Injectable },
    ];
    InputManager.ctorParameters = function () { return []; };
    return InputManager;
}());
export { InputManager };
//# sourceMappingURL=input-manager.js.map